// src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBhpe8n_QiB4DNcWE3R1G7dhwcCRdSi6mk",
  authDomain: "bharat-connect-6c9b2.firebaseapp.com",
  databaseURL: "https://bharat-connect-6c9b2-default-rtdb.firebaseio.com/",
  projectId: "bharat-connect-6c9b2",
  storageBucket: "bharat-connect-6c9b2.appspot.com",
  messagingSenderId: "326971283598",
  appId: "1:326971283598:web:d1beb5034bed87f821d1df",
  measurementId: "G-DK920C0Y21"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getDatabase(app);
